import {
  type PredictionRewardProfile,
  type PrizeAllocationRule,
} from './predictionRewardProfile'
import { ALLOCATION_RULE_LABELS } from './predictionRewardLabels'

type Props = {
  rewardProfile?: PredictionRewardProfile | null
  prizeInfo?: {
    headline?: string
    description?: string
    rewardTypes?: string[]
    extraNote?: string
  } | null
}

const REWARD_TYPE_LABELS: Record<string, string> = {
  ODDS: 'โบนัสตาม Odds',
  POINTS_BONUS: 'โบนัสพอยท์',
  PHYSICAL: 'ของรางวัล',
  CUSTOM: 'รางวัลพิเศษ',
}

export default function PredictionRewardInfoCard({ rewardProfile, prizeInfo }: Props) {
  const headline = rewardProfile?.promoHeadline || prizeInfo?.headline
  const description = rewardProfile?.promoDescription || prizeInfo?.description
  const extraNote = rewardProfile?.promoExtraNote || prizeInfo?.extraNote
  const prizes = (rewardProfile?.prizes || []).filter((p) => p.enabled !== false && p.name)

  if (!headline && !description && !prizes.length && !prizeInfo?.rewardTypes?.length) {
    return null
  }

  return (
    <div className="pred-reward-card">
      <div className="pred-reward-card__head">🎁 รางวัล / สิ่งที่ได้รับ</div>

      {headline && <div className="pred-reward-card__title">{headline}</div>}
      {description && (
        <p className="pred-reward-card__body mb-2" style={{ whiteSpace: 'pre-wrap' }}>{description}</p>
      )}

      {prizeInfo?.rewardTypes && prizeInfo.rewardTypes.length > 0 && (
        <div className="mb-2">
          {prizeInfo.rewardTypes.map((t) => (
            <span key={t} className="pred-reward-badge">{REWARD_TYPE_LABELS[t] || t}</span>
          ))}
        </div>
      )}

      {prizes.length > 0 && (
        <ul className="pred-reward-card__body mb-2 ps-3">
          {prizes.map((p) => (
            <li key={p.prizeId}>
              <strong>{p.name}</strong>
              {p.quantity > 1 && ` ×${p.quantity}`}
              {' '}
              <span>
                ({ALLOCATION_RULE_LABELS[p.allocationRule as PrizeAllocationRule] || p.allocationRule})
              </span>
              {p.description && <div>{p.description}</div>}
            </li>
          ))}
        </ul>
      )}

      {rewardProfile?.monetaryEnabled && (
        <p className="pred-reward-card__body mb-0">+ จ่ายตาม Odds อัตโนมัติเมื่อทายถูก</p>
      )}

      {extraNote && <p className="pred-reward-card__body mb-0 mt-2" style={{ color: '#fcd34d' }}>* {extraNote}</p>}
    </div>
  )
}
